import ApplicationAdapter from './application';

export default class User extends ApplicationAdapter {
  namespace = 'auth/v4';
  modelNamePlural = 'users';
}
